import defaultAttributes from "backend/defaultAttributes";
import { getChildHierarchy } from "backend/model/getChildHierarchy";
import { ICardElementWithChildren } from "backend/model/model";
import isDraftFilterAtLocation from "qpr-base/attributes/drafts/disabledPages";
import { useQuery } from "react-query";
import usePeriodFromString from "../model/usePeriodFromString";
import usePeriodLevels from "../model/usePeriodLevels";

const useHierarchy = (
  id?: string,
  depth?: number,
  period?: string,
  disable?: boolean
) => {
  const { data: periodLevels } = usePeriodLevels();

  const currentPeriod = usePeriodFromString(period);
  const usingPeriod = currentPeriod?.name || "";

  return useQuery(
    `data-children-${id}-${usingPeriod}-${depth}-${isDraftFilterAtLocation()}`,
    () => {
      if (disable === true)
        return (async (): Promise<ICardElementWithChildren[]> => [])(); // return empty array

      return getChildHierarchy(
        id || "",
        (q) =>
          q.attributes(
            ...defaultAttributes(currentPeriod?.name, periodLevels!!)
          ),
        depth || 10,
        currentPeriod!,
        periodLevels!
      );
    },
    {
      enabled: !!id,
      cacheTime: 1,
      staleTime: 1,
    }
  );
};

export default useHierarchy;
